import React from 'react';
import { useNotifications } from '../../contexts/NotificationContext';
import './NotificationToast.css';

const TYPE_ICONS = {
  info: '\u2139\uFE0F',
  success: '\u2705',
  warning: '\u26A0\uFE0F',
  match: '\uD83C\uDFAE',
  veto: '\uD83D\uDDFA\uFE0F',
};

export default function NotificationToast() {
  const { notifications, dismissNotification } = useNotifications();

  const toasts = notifications.filter(n => !n.dismissed).slice(0, 3);

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container">
      {toasts.map(n => (
        <div
          key={n.id}
          className={`toast toast-${n.type} ${n.dismissed ? 'toast-exit' : ''}`}
          onClick={() => {
            if (n.action) n.action();
            dismissNotification(n.id);
          }}
        >
          <span className="toast-icon">{TYPE_ICONS[n.type] || TYPE_ICONS.info}</span>
          <span className="toast-message">{n.message}</span>
          <button
            className="toast-close"
            onClick={(e) => { e.stopPropagation(); dismissNotification(n.id); }}
          >
            &times;
          </button>
        </div>
      ))}
    </div>
  );
}
